import { Component, Input, OnInit,LOCALE_ID } from '@angular/core'
import { DatePipe } from '@angular/common'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
const KEY = 'formulaire-information'

import * as moment from 'moment'
import { DateAdapter, MatDatepickerInputEvent , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';


@Component({
	selector: 'atyl-formulaire-information',
	templateUrl: './formulaire-information.component.html',
	styleUrls: ['./formulaire-information.component.scss']	,
			 providers: [
		    { provide: LOCALE_ID, useValue: 'fr-FR' },
		    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
		    {
		      provide: DateAdapter,
		      useClass: MomentDateAdapter,
		      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
		    },
		    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
		    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
		    {
		      provide: MAT_DATE_FORMATS, useValue: {
		        parse: {
		          dateInput: 'L',
		        },
		        display: {
		          dateInput: 'L',
		          monthYearLabel: 'MMM YYYY',
		          dateA11yLabel: 'L',
		          monthYearA11yLabel: 'MMM YYYY',
		        },
		      }
		    },
	],
})

@Stringable({
	path: 'views/partials/layout/formulaire-information',
	key: KEY,
})

export class FormulaireInformationComponent implements OnInit {
	@StringableValues(KEY)
	strings: any

	@Input() formulaire: any = {}
	message: string = ""

	@Input() formatdate: string = "dd LLLL yyyy";
	@Input() createLabel: string = "Crée";
	@Input() modifyLabel: string = "Modifié";
	form:any;
	
	constructor(
		private datePipe: DatePipe,
	) {}

	ngOnInit(): void {
		this.form = this.formulaire.demandeFormulaire || this.formulaire

		if (!this.form) return
        
		let cr:string[]=[];
		
		if (this.form.createur!=undefined ) {
			const createur = this.form.createur;
			cr.push(`par ${createur.prenom || ""} ${createur.nom || ""}`);
		}
		if (this.form.creationdate!=undefined ) {
			const creationDate = this.form.creationdate
			const formattedDate = this.datePipe.transform(new Date(creationDate), this.formatdate)
			if (formattedDate) cr.push(`le ${formattedDate}`);
		}	
		if (cr.length>0)
			this.message +=this.createLabel+" "+cr.join("\n");
		
		let md:string[]=[];
		
		if (this.form.modificateur!=undefined ) {
			const modificateur = this.form.modificateur;
			md.push(`par ${modificateur.prenom || ""} ${modificateur.nom || ""}`);
		}
		if (this.form.modificationdate!=undefined ) {
			
			const modifDate = this.form.modificationdate
			const modifFormattedDate = this.datePipe.transform(new Date(modifDate), this.formatdate)
			           //console.log("FormulaireInformationComponent modificateur",modificateur,modifFormattedDate)
		      if (modifFormattedDate) md.push(`le ${modifFormattedDate}`);
		}	
		if (md.length>0) {
			if (this.message.length>0)
				this.message +="\n";
			this.message +=this.modifyLabel+" "+md.join("\n");
		}
		/*
		if (this.form.createur!=undefined 
		&& this.form.createur ) {
			const createur = this.form.createur
			
			this.message += `Crée par : ${createur.prenom || ""} ${createur.nom || ""}\n`
			
			const creationDate = this.form.creationdate
			const formattedDate = this.datePipe.transform(new Date(creationDate), "dd LLLL yyyy")
			if (formattedDate) this.message += `Crée le ${formattedDate}`
			//console.log("FormulaireInformationComponent createur",createur,formattedDate)
			
		}
		*/
		/*
		if (this.form.modificateur!=undefined
		 && this.form.modificateur) {
			const modificateur = this.form.modificateur
			const modifDate = this.form.modificationdate
			const modifFormattedDate = this.datePipe.transform(new Date(modifDate), "dd LLLL yyyy")
           //console.log("FormulaireInformationComponent modificateur",modificateur,modifFormattedDate)
			this.message += `\n\nModifié par : ${modificateur.prenom || ""} ${modificateur.nom || ""}\n`
			if (modifFormattedDate) this.message += `Modifié le ${modifFormattedDate}`
		
			
		}
		*/
	}
	
	_getTitleArchive() {
			let title:string[]=[];
			
			title.push("Archivé");
			if (this.form!=undefined &&
				 this.form.archive_date!=undefined
				  && this.form.archive_date) {
				let dt:any = moment(this.form.archive_date);
				if (dt instanceof moment) {
					title.push("Le "+ moment(this.form.archive_date).format('DD/MM/YYYY'));
					
				}
			}
			
			return title.join("\n");
	}	
	
}